import React, { useEffect, useState } from "react";
import "./loader.css";
/* import Loaders from "react-loaders";
import Global from "../../global"; */

const Loader = (props) => {
  const [loadingType, SetLoadingType] = useState("");

  useEffect(() => {
    SetLoadingType(props.load);
  }, [props.load]);

  if (loadingType === "Default" || loadingType === "") {
    return (
      <div className="background-2 loader loader-border is-active" data-text="">
        <div className="login-logo">
          <a href="index.html">
            <img
              src="/images/primlogo.png"
              alt="logo"
              style={{
                width: "auto",
                height: "65px",
                animation: "beat .85s infinite",
              }}
            ></img>
          </a>
        </div>
      </div>
    );
  } else {
    return (
      <div className="background-2 loader loader-border is-active" data-text="">
        <div className="login-logo">
          <a href="index.html">
            <img
              src="/images/primlogo.png"
              alt="logo"
              style={{
                width: "auto",
                height: "65px",
                animation: "beat .85s infinite",
              }}
            ></img>
          </a>
        </div>
      </div>
    );
  }
};

export default Loader;
